// extracted by mini-css-extract-plugin
export default {"sideBar":"style_sideBar__-H88h","content-name-user":"style_content-name-user__3-7wb"};